module.exports = __webpack_public_path__ + "images/d9c82cfcdaef3c0dddc9509af3dd37b6-illu_cloth.svg";